import axios from "./HTTP";

export default {
  managerOf(userId, callback, errorCallback) {
    axios
      .get(`/api/manager_of.json`, { params: { user_id: userId } })
      .then(response => {
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  getAll(userId, callback) {
    axios
      .get("/api/employees.json", { params: { user_id: userId } }) // but only employees of this user
      .then(response => callback(response.data));
  },

  get(employeeId, callback) {
    axios
      .get(`/api/employees/${employeeId}.json`)
      .then(response => callback(response.data));
  },

  update(idAndFields, callback, errorCallback) {
    axios
      .patch(`/api/managers/${idAndFields.id}.json`, idAndFields)
      .then(response => {
        console.log(response);
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  savePhoto(idAndFields, callback, errorCallback) {
    axios
      .patch(`/api/employees/${idAndFields.id}/save_photo.json`, idAndFields)
      .then(response => {
        console.log(response);
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  saveCertification(idAndFields, callback, errorCallback) {
    axios
      .patch(
        `/api/employees/${idAndFields.id}/save_certification.json`,
        idAndFields
      )
      .then(response => {
        console.log(response);
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  addTeam(params, callback, errorCallback) {
    axios
      .post(`/api/employees/${params.id}/add_teams.json`, params)
      .then(response => {
        console.log(response);
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  pullOffTeam(params, callback, errorCallback) {
    axios
      .patch(`/api/employees/${params.id}/remove_teams.json`, params)
      .then(response => {
        console.log(response);
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  create(params, callback, errorCallback) {
    axios
      .post(`/api/managers.json`, {
        manager: {
          first_name: params.firstName,
          last_name: params.lastName,
          email: params.email
        }
      })
      .then(response => {
        console.log(response);
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  deactivate(managerID) {
    return axios.post(`/api/managers/${managerID}/deactivate.json`);
  },

  activate(managerID) {
    return axios.post(`/api/managers/${managerID}/activate.json`);
  },

  addSkill(idSkill, callback, errorCallback) {
    axios
      .patch(`/api/employees/${idSkill.id}/add_skill.json`, idSkill)
      .then(response => {
        console.log(response);
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },
  removeSkill(idSkill, callback, errorCallback) {
    axios
      .patch(`/api/employees/${idSkill.id}/remove_skill.json`, idSkill)
      .then(response => {
        console.log(response);
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  removeERContact(contactID, callback, errorCallback) {
    axios
      .delete(`/api/emergency_contacts/${contactID}.json`)
      .then(response => {
        console.log(response);
        callback(response.data);
      })
      .catch(error => {
        errorCallback(error);
      });
  },

  addRemoveSkill(idSkillPresent, callback, errorCallback) {
    axios
      .patch(`/api/employees/${idSkillPresent.id}/skills.json`, idSkillPresent)
      .then(response => {
        console.log(response);
      });
  },

  getManagers(userID, callback, errorCallback) {
    axios
      .get(`/api/managers.json`, { params: { for_user_id: userID } })
      .then(response => callback(response.data));
  },

  getAllManagers(callback, errorCallback) {
    axios
      .get(`/api/managers.json`)
      .then(response => callback(response.data))
      .catch(err => errorCallback(err));
  },

  getManager(managerId, callback, errorCallback) {
    axios
      .get(`/api/managers/${managerId}.json`)
      .then(response => callback(response.data))
      .catch(err => errorCallback(err));
  },

  getPrimaryPositions(userID, callback, errorCallback) {
    axios
      .get(`/api/employee_positions.json`, { params: { for_user_id: userID } })
      .then(response => callback(response.data));
  }
};
